import React from 'react';
import BaseDialog from '../BaseDialog';

const DailyPointClaimedDialog = ({ isVisible, onClose, message }) => {
  return (
    <BaseDialog isVisible={isVisible} onClose={onClose} maxWidth="min(92vw, 420px)">
      <div style={{ padding: '8px 4px' }}>
        <div style={{ fontSize: '18px', fontWeight: 'bold', marginBottom: '10px', color: '#12344d' }}>
          参加チケットを受け取りました
        </div>
        <div style={{ fontSize: '14px', color: '#333', marginBottom: '16px', whiteSpace: 'pre-wrap', lineHeight: 1.6 }}>
          {message || '参加チケットの受取が完了しました。'}
        </div>
        <button
          type="button"
          onClick={onClose}
          style={{
            padding: '9px 16px',
            border: 'none',
            borderRadius: '999px',
            backgroundColor: '#1976d2',
            color: '#fff',
            cursor: 'pointer',
            fontWeight: 700,
          }}
        >
          OK
        </button>
      </div>
    </BaseDialog>
  );
};

export default DailyPointClaimedDialog;
